'use client';

import { Button as MokoButton } from '@mokoboko/components';

import { useOpenSitePage } from '@/hooks/use-open-site-page';
import { CANCELED_CLASS_TITLE } from '@/lib/seo';
import { EmptyCalendarState } from './empty-calendar-state';
import { PageContainer } from './page-container';

export const SeeAllClassesState = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  const openPage = useOpenSitePage();

  return (
    <EmptyCalendarState
      title={title}
      description={description}
      primaryAction={
        <MokoButton
          size="lg"
          onClick={() =>
            openPage('/classes', 'Allow pop-ups to see all classes.')
          }
        >
          See all classes
        </MokoButton>
      }
    />
  );
};

// A one-time class whose only date was canceled, closed or taken by a day off.
// The class itself is kept so the studio can unblock the date, but nothing on
// it can be booked, so the customer is told so and pointed at the list.
export const ClassCanceledState = () => (
  <SeeAllClassesState
    title={CANCELED_CLASS_TITLE}
    description="You can book another class instead."
  />
);

export const ClassCanceledPage = () => (
  <PageContainer className="ground-empty-state on-ground flex items-center justify-center">
    <ClassCanceledState />
  </PageContainer>
);
